import React from 'react'

interface ContactEllipsesProps {
  size?: number
  color?: string
  secondColor?: string
}

export const ContactEllipses: React.FC<ContactEllipsesProps> = ({
  size = 110,
  color = '#4E45FF',
  secondColor = '#4732FF',
}) => (
  <svg width={size} height={size} viewBox="0 0 111 110" fill="none">
    <circle cx={55.5} cy={55} r={55} fill={color} fillOpacity={0.1} />
    <circle cx={55.5} cy={55} r={45} fill={color} fillOpacity={0.4} />
    <rect
      x={23.5}
      y={23}
      width={64}
      height={64}
      rx={32}
      fill="url(#paint0_linear_contact_ellipses)"
    />
    <path
      d="M69.129 48.744c-.514-7.028-6.429-12.6-13.629-12.6-7.2 0-13.114 5.572-13.627 12.6-3 .686-5.228 3.258-5.228 6.258s2.227 5.572 5.227 6.256c.514 7.03 6.428 12.6 13.629 12.6h3.43a1.714 1.714 0 000-3.428H55.5c-5.657 0-10.286-4.628-10.286-10.286V49.86c0-5.656 4.63-10.284 10.285-10.284 5.658 0 10.287 4.628 10.287 10.284v9.858a1.72 1.72 0 001.713 1.714c3.772 0 6.859-2.914 6.859-6.428 0-3-2.228-5.572-5.228-6.258l-.002-.002zm-29.057 6.258c0-1.114.686-2.058 1.714-2.572v5.144c-1.028-.516-1.714-1.458-1.714-2.572zm29.142 2.572V52.43c1.03.514 1.716 1.458 1.716 2.572s-.686 2.056-1.716 2.572z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="paint0_linear_contact_ellipses"
        x1={10.3718}
        y1={69.2222}
        x2={87.5853}
        y2={90.2079}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#68F" />
        <stop offset={1} stopColor={secondColor} />
      </linearGradient>
    </defs>
  </svg>
)
